module.exports = __webpack_public_path__ + "static/media/offline.52470f0f.png";